// Configuration de l'application
export const GRAPHHOPPER_API_KEY = '01f34acc-7d71-4dc0-98ed-c1e7941d12c3';

// Credentials sécurisés (hashés)
export const CREDENTIALS = {
    username: btoa('Frédéric'),
    passwordHash: btoa('mQzcmX4c7Uxa2ufJ' + 'salt_gravel_2024')
};

// Couleurs des surfaces
export const SURFACE_COLORS = {
    'asphalt': '#2196f3',
    'concrete': '#607d8b',
    'paved': '#9c27b0',
    'paving_stones': '#9c27b0',
    'gravel': '#ff9800',
    'fine_gravel': '#ffb74d',
    'dirt': '#8d6e63',
    'earth': '#8d6e63',
    'ground': '#a1887f',
    'grass': '#4caf50',
    'grass_paver': '#66bb6a',
    'sand': '#ffd54f',
    'wood': '#795548',
    'compacted': '#9e9e9e',
    'unpaved': '#757575',
    'unknown': '#bdbdbd',
    'missing': '#e0e0e0'
};

// Labels des surfaces
export const SURFACE_LABELS = {
    'asphalt': 'Asphalte',
    'concrete': 'Béton',
    'paved': 'Pavé',
    'gravel': 'Gravier',
    'dirt': 'Terre',
    'grass': 'Herbe',
    'ground': 'Sol naturel',
    'unpaved': 'Non pavé',
    'compacted': 'Compacté',
    'unknown': 'Inconnu',
    'missing': 'Non renseigné'
};

// Préférences de surface par défaut
export const DEFAULT_SURFACE_PREFERENCES = {
    asphalt: 20,
    gravel: 40,
    dirt: 20,
    grass: 10,
    paved: 10
};

// Icônes des surfaces
export const SURFACE_ICONS = {
    asphalt: '🛣️',
    gravel: '🪨',
    dirt: '🌍',
    grass: '🌱',
    paved: '🧱'
};